document.addEventListener( 'DOMContentLoaded', () => {
  if ( isDesktop() ) return;

  initMobileTableView();
} );

function isDesktop() {
  return window.innerWidth >= 576;
}

function initMobileTableView() {
  addVendorsHeader();
  transformTableRows();
  initializeStyles();
  setupTriggers();
}

function addVendorsHeader() {
  const thead = document.querySelector( 'thead' );
  if ( !thead ) return;

  const headerDiv = createDiv( 'vendors-header', 'VENDORS' );
  thead.appendChild( headerDiv );
}

function transformTableRows() {
  const rows = document.querySelectorAll( '.community-table table tr' );

  rows.forEach( row => {
    if ( isHeaderRow( row ) ) {
      row.remove();
    } else {
      const caption = getCaption( row );
      const headerTexts = getHeaderTexts( row );
      const newBox = buildBoxFromRow( row, caption, headerTexts );
      row.replaceWith( newBox );
    }
  } );
}

function isHeaderRow( row ) {
  return row.querySelectorAll( 'th' ).length > 0;
}

function getCaption( row ) {
  const firstCell = row.querySelector( 'td' );
  return firstCell?.textContent || '';
}

function getHeaderTexts( row ) {
  const headers = row.querySelectorAll( 'th' );
  return Array.from( headers ).map( th => th.textContent || '' );
}

function buildBoxFromRow( row, caption, headerTexts ) {
  const box = createDiv( 'box' );
  const trigger = createDiv( 'trigger', caption );
  const toggleContainer = createDiv( 'toggle_container' );

  row.querySelectorAll( 'td' ).forEach( ( cell, index ) => {
    const label = createDiv( 'label', headerTexts[index] || '' );
    const data = createDiv( 'data' );
    data.innerHTML = cell.innerHTML;

    const innerContent = createDiv( 'inner-content' );
    innerContent.append( label, data );

    const inner = createDiv( 'inner' );
    inner.appendChild( innerContent );

    toggleContainer.appendChild( inner );
  } );

  box.append( trigger, toggleContainer );
  return box;
}

function createDiv( className, text = '' ) {
  const el = document.createElement( 'div' );
  el.className = className;
  if ( text ) el.textContent = text;
  return el;
}

function initializeStyles() {
  hideToggleContainers();
  removeWrapperClasses();
}

function hideToggleContainers() {
  document.querySelectorAll( '.toggle_container' ).forEach( container => {
    container.style.height = '0';
    container.style.overflow = 'hidden';
  } );
}

function removeWrapperClasses() {
  document.querySelectorAll( '.box' ).forEach( box => {
    box.classList.remove( 'box_wraper' );
  } );
}

function setupTriggers() {
  document.querySelectorAll( '.trigger' ).forEach( trigger => {
    trigger.addEventListener( 'click', () => handleTriggerClick( trigger ) );
  } );
}

function handleTriggerClick( trigger ) {
  const box = trigger.parentElement;
  const toggle = trigger.nextElementSibling;
  if ( !box || !toggle ) return;

  const activeToggle = getOtherActiveToggle( box.parentElement, toggle );

  if ( activeToggle ) {
    collapseToggle( activeToggle );
    activeToggle.parentElement?.classList.remove( 'box_wraper' );
  }

  toggle.classList.contains( 'active' )
    ? deactivateToggle( toggle, box )
    : activateToggle( toggle, box );
}

function getOtherActiveToggle( parent, currentToggle ) {
  const active = parent?.querySelector( '.toggle_container.active' );
  return active && active !== currentToggle ? active : null;
}

function activateToggle( toggle, box ) {
  expandToggle( toggle );
  box.classList.add( 'box_wraper' );
}

function deactivateToggle( toggle, box ) {
  collapseToggle( toggle );
  box.classList.remove( 'box_wraper' );
}

function expandToggle( el ) {
  el.classList.add( 'active' );
  el.style.display = 'block';
  el.style.height = `${el.scrollHeight}px`;
  setTimeout( () => {
    el.style.height = 'auto';
  }, 300 );
}

function collapseToggle( el ) {
  el.style.height = `${el.scrollHeight}px`;
  requestAnimationFrame( () => {
    el.style.height = '0';
  } );
  el.classList.remove( 'active' );
}
